<template>
  <div class="program-list">
    <msg-dialog :dialogVisible="dialogVisible" @closeDialog="closeDialog" dWidth="1100px"
      :title="$t('terminal.programList')">
      <div class="equipment">
        <div class="equipment-left">
          <trees type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
        </div>
        <div class="equipment-right">
          <div class="program-table" :key="now">
            <el-table ref="multipleTable" row-key="id" @selection-change="handleSelectionChange" :data="programList"
              style="width: 100%" height="100%" v-loading="loading" @row-click="tableRowClick">
              <!-- 多选节目 -->
              <el-table-column v-if="isCheckbox" type="selection" :reserve-selection="true"
                :selectable="checkboxInit"></el-table-column>
              <!-- 单选节目 -->
              <el-table-column v-else width="50">
                <template #default="{ row }">
                  <el-radio :disabled="!checkboxInit(row)" v-model="currentRowKey" :label="row.id">
                    <i style="color: #fff;">.</i>
                  </el-radio>
                </template>
              </el-table-column>

              <el-table-column :label="$t('schedule.Screenshot')" width="120">
                <template slot-scope="scope">
                  <div class="operation">
                    <img style="width: 96px; height: 54px;object-fit: contain;" v-if="scope.row.damaged === 0"
                      :src="scope.row.pimg" alt />
                    <img style="width: 96px; height: 54px;" v-else src="@imgpub/damaged.png" alt />
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="name" :label="$t('schedule.ProgramName')"></el-table-column>
              <el-table-column prop="size_remark" :label="$t('schedule.Resolution')"></el-table-column>
              <el-table-column prop="group_name" :label="$t('schedule.Structure')"></el-table-column>
              <el-table-column prop="play_time" :label="$t('cbu7')">
                <template slot-scope="scope">
                  {{ scope.row.play_time | playTime }}
                </template>
              </el-table-column>
              <el-table-column prop="create_time" :label="$t('schedule.CreationTime')" width="160"></el-table-column>
            </el-table>
            <transition name="slide-up-height">
              <div v-if="isSchedule" class="ts-set">
                <div class="aaic-item">
                  <div class="flex-a-c">
                    <div style="font-size: 14px;color: #606266;padding-right: 10px;">
                      {{ $t('csce17') }}
                    </div>
                    <el-input-number size="mini" v-model="playCount" :min="1"
                      @change="(val) => { changeValue('playCount', val) }"></el-input-number>
                  </div>
                  <div class="flex-a-c">
                    <div style="font-size: 14px;color: #606266;padding-right: 10px;">
                      {{ $t('csce18') }}
                    </div>
                    <el-input-number size="mini" v-model="allNumber" :min="0"
                      @change="(val) => { changeValue('allNumber', val) }"></el-input-number>
                  </div>
                </div>
                <div class="aaic-item">
                  <div style="font-size: 14px;color: #606266;">
                    {{ $t('cdck10') }}
                  </div>
                  <el-time-picker size="mini" is-range v-model="playTime" :range-separator="$t('ctce5')"
                    :start-placeholder="$t('ctce4')" :end-placeholder="$t('ctce6')" :placeholder="$t('actd1')"
                    @change="(val) => { changeValue('playTime', val) }">
                  </el-time-picker>
                </div>
                <div class="aaic-item">
                  <el-radio-group v-model="isDateLimit" @change="(val) => { changeValue('isDateLimit', val) }">
                    <el-radio :label="0">{{
                      $t('terminal.noLimit') }}</el-radio>
                    <el-radio :label="1">{{
                      $t('terminal.speDate') }}</el-radio>
                  </el-radio-group>
                  <el-date-picker style="width: 386px;" :disabled="isDateLimit == 0" v-model="playDate" type="daterange"
                    :range-separator="$t('ctce5')" :start-placeholder="$t('ctce4')" :end-placeholder="$t('ctce6')"
                    size="mini" @change="(val) => { changeValue('playDate', val) }">
                  </el-date-picker>
                </div>
                <div class="aaic-item">
                  <el-radio-group v-model="isWeekLimit" @change="(val) => { changeValue('isWeekLimit', val) }">
                    <el-radio :label="0">{{
                      $t('terminal.noLimit') }}</el-radio>
                    <el-radio :label="1">{{
                      $t('terminal.speWeek') }}</el-radio>
                  </el-radio-group>

                  <el-checkbox-group v-model="validWeek" :disabled="isWeekLimit == 0" size="mini"
                    @change="(val) => { changeValue('validWeek', val) }">
                    <el-checkbox-button v-for="week in weeks" :label="week" :key="week">{{ $t(week_intl[week]) }}
                    </el-checkbox-button>
                  </el-checkbox-group>
                </div>
              </div>
            </transition>
          </div>
          <div class="flex-b-c program-control">
            <div style="width: 80px;padding-bottom: 28px;">
              <span  v-show="multipleSelection.length">{{ $t('terminal.selected') }}({{
                multipleSelection.length }})</span>
            </div>
            <div class="flex-b-c" style="width: 90%;">
              <div class="flex-b-c" style="width: 100%;">
                <div @click="isSchedule = !isSchedule">
                  <template v-if="isShowSchedule">
                    <img class="icon" src="@/assets/images/public/time.png" alt style="margin-bottom: 24px;" />
                  </template>
                </div>
                <div style="height: 60px;margin: 8px 0px;position: relative;z-index: 999;" class="flex-d-c-c">
                  <el-input v-model="keyword" size="mini" @input="keywordInput" style="width: 200px;">
                    <i slot="suffix" class="el-input__icon el-icon-search icon" @click="search(keyword)"></i>
                  </el-input>
                  <pagination :page="page" :pagerCount="5" :current="current" :limit="limit"
                    @currentChange="currentChange">
                  </pagination>
                </div>
              </div>
              <!-- <div class="flex-d-a-c icon" style="margin-bottom: 20px;user-select: none;"
                @click="isSchedule = !isSchedule" v-if="isShowSchedule">
                <i class="el-icon-arrow-up " style="color:var(--theme-color-customized-1)"></i>
                <i class="el-icon-time" style="color:var(--theme-color-customized-1)">{{ $t('act5') }}</i>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="button">
          <el-button round @click="cancel">{{ $t('basics.Cancel') }}</el-button>
          <el-button round type="primary" @click="confirm">{{
            $t('basics.Confirm') }}</el-button>
        </div>
      </div>
    </msg-dialog>
  </div>
</template>

<script>
import MsgDialog from '@/components/basics/FormDialog'
import { mPagination } from "@/components/basics/mixins";
import trees from '@/components/basics/Trees';
import pagination from '@/components/basics/Pagination';
import { msFormatting } from "@/assets/scripts/dateFormatting.js";
import { weekFormatting, dateFormatting, timeFormatting, reWeekFormatting, reTimeFormatting, } from "@/assets/scripts/dateFormatting";

const weeks = ['一', '二', '三', '四', '五', '六', '日'];
const week_intl = { '一': 'terminal.Monday', '二': 'terminal.Tuesday', '三': 'terminal.Wednesday', '四': 'terminal.Thursday', '五': 'terminal.Friday', '六': 'terminal.Saturday', '日': 'terminal.Sunday' };

export default {
  name: 'ProgramList',
  mixins: [mPagination],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    defaultPName: {
      type: String,
      default: ''
    },
    isCheckbox: {
      type: Boolean,
      default: true
    },
    isShowSchedule: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      groupList: [],
      keyword: "",
      programList: [],
      multipleSelection: [],
      loading: false,
      currentRowKey: null,
      now: Date.now(),
      isSchedule: false,
      // 排程配置参数
      playCount: 1,
      allNumber: 0,
      playTime: [reTimeFormatting("00:00:00"), reTimeFormatting("23:59:59")],
      isDateLimit: 0,
      playDate: [new Date(), new Date()],
      isWeekLimit: 0,
      validWeek: reWeekFormatting(0),
      weeks,
      week_intl
    }
  },
  created() {
    this.getGroupList();
    this.getProgramList();
  },
  methods: {
    changeValue(key, value) {
      let data = {};
      switch (key) {
        case 'playTime': {
          const [startTime, endTime] = value;
          data = {
            startTime: timeFormatting(startTime),
            endTime: timeFormatting(endTime)
          };
        }
          break;
        case 'playDate': {
          const [dateStart, dateEnd] = value;
          data = {
            dateStart: dateFormatting(dateStart),
            dateEnd: dateFormatting(dateEnd)
          };
        }
          break;
        case 'validWeek':
          data = { validWeek: weekFormatting(value) };
          break;
        case 'playCount':
        case 'allNumber':
        case 'isDateLimit':
        case 'isWeekLimit':
          data = { [key]: value };
          break;
        default:
          break;
      }
      console.log(data);
    },
    init() {
      this.loading = false;
    },
    closeDialog() {
      this.adapterScreen = false;
      this.$emit("closeDialog", []);
    },
    //组织结构切换重新加载关联设备
    getAssets(ids) {
      if (ids.type === "GROUP") {
        this.groupIds = ids.ids;
      }
      this.currentChange(1);
    },
    keywordInput(keyword) {
      if (!keyword) {
        this.currentChange(1);
      }
    },
    getGroupList() {
      this.$http.post("/admin/access/groupList", {}, data => {
        this.groupList = data;
      });
    },
    currentChange(val) {
      console.log(val);
      this.page = val;
      this.getProgramList();
    },
    cancel() {
      this.$emit("selectProgramList", []);
    },
    confirm() {
      if (this.isShowSchedule) {
        this.$emit("selectProgramList", this.multipleSelection, {
          playCount: this.playCount,
          allNumber: this.allNumber,
          startTime: timeFormatting(this.playTime[0]),
          endTime: timeFormatting(this.playTime[1]),
          isDateLimit: this.isDateLimit,
          dateStart: dateFormatting(this.playDate[0]),
          dateEnd: dateFormatting(this.playDate[1]),
          isWeekLimit: this.isWeekLimit,
          validWeek: weekFormatting(this.validWeek),
        });
      } else {
        this.$emit("selectProgramList", this.multipleSelection);
      }

    },
    search(keyword) {
      this.keyword = keyword;
      this.getProgramList();
    },
    getProgramList(args = {
      group_ids: this.groupIds,
      limit: this.limit,
      page: this.page,
      key_word: this.keyword
    }) {
      this.loading = true;
      return this.$http.post("/admin/play/list", args, data => {
        this.programList = data.list ? data.list : [];
        this.current = data.count ? parseInt(data.count) : 0;
        this.loading = false;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    tableRowClick(row) {
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    checkboxInit(row) {
      return row.play_state === -1 || row.play_state === 2;
    },
  },
  filters: {
    playTime(value) {
      return value ? msFormatting(value) : "--:--:--";
    }
  },
  watch: {
    dialogVisible: {
      handler(nd) {
        nd && this.init();
        this.isSchedule = false;
      }
    },
    isCheckbox: {
      handler() {
        this.now = Date.now();
      }
    }
  },
  components: {
    MsgDialog,
    trees,
    pagination
  }
}
</script>

<style lang="scss" scoped>
/* 定义高度变化动画 */
.slide-up-height-enter-active,
.slide-up-height-leave-active {
  transition: max-height 0.5s ease, opacity 0.5s ease;
  max-height: 500px;
  /* 最大高度（根据内容调整） */
  overflow: hidden;
}

.slide-up-height-enter,
.slide-up-height-leave-to {
  max-height: 0;
  opacity: 0;
}

.program-list {
  .equipment {
    display: flex;
    height: 500px;

    .equipment-left {
      flex: 0 0 240px;
      border: 1px solid #edfbff;
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .equipment-right {
      margin-left: 8px;
      flex: 1;
      border-radius: 8px;

      .program-table {
        height: calc(100% - 40px);
        overflow-y: auto;
        position: relative;

        .ts-set {
          position: absolute;
          width: calc(100% - 18px);
          height: 150px;
          bottom: 0px;
          background-color: #edfbff;
          z-index: 2;
          // border-radius: 8px 8px 0px 0px;
          border-radius: 8px;
          padding: 8px;
          border: 1px solid #409EFF;

          .aaic-item {
            margin: 8px 0px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 10px;
          }
        }
      }

      .program-control {
        position: relative;

        /deep/ .el-input__inner {
          border-radius: 20px;
        }
      }
    }

    /deep/ .el-table__header-wrapper {
      .cell {
        font-size: 18px;
        color: var(--theme-color-customized-1);
      }

      th:last-child>.cell {
        text-align: center;
      }
    }
  }

  .footer {
    width: 100%;
    height: 60px;
    position: relative;

    .button {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
